export default __webpack_public_path__ + "static/media/PowerShield.4e29f202.svg";